import React from 'react';

import PropTypes from 'prop-types';

const Label = ({ labelName }) => {
  return (
    <div className="main-content-form-headers" style={{ marginBottom: '9px' }}>
      <span className="select-placeholder">{labelName}</span>
    </div>
  );
};

Label.propTypes = {
  labelName: PropTypes.string.isRequired
};

export default Label;
